import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DocumentoModel } from 'src/app/modules/crm/modules/applications/models/documento.model';

// TODO merge it with filepicker component
@Component({
  selector: 'app-documentopicker',
  templateUrl: './documentopicker.component.html',
  styleUrls: ['./documentopicker.component.scss']
})
export class DocumentopickerComponent implements OnInit {

  @Input() model!: DocumentoModel;
  @Input() label = 'Upload';
  @Input() accept = 'image/*';
  @Input() edit = false;
  @Output() modelChange = new EventEmitter<DocumentoModel>();

  loading = false;

  constructor() { }

  ngOnInit(): void {
  }

  onUpload(event: any): void {
    this.loading = false;
    this.modelChange.emit(this.toDocumentoModel(event));
  }

  toDocumentoModel(event: any): DocumentoModel {
    this.model.created = event.originalEvent.body.created;
    this.model.path = event.originalEvent.body.uuid + '.' + event.originalEvent.body.ext;
    this.model.nome = event.originalEvent.body.filename;
    return this.model;
  }

  onSelect(){
    this.loading = true;
  }

  onFinish(){
    this.loading = false;
  }

}
